import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "14px",
	height: "14px",
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Shape" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Wireframes-Mobile-Agent-Yulia",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Home---Suche-02",
				transform: "translate(-21.000000, -762.000000)",
				fill: "#C0C0C0",
				children: /* @__PURE__ */ _jsx("polygon", {
					id: "Shape",
					points: "27 762 27 768 21 768 21 770 27 770 27 776 29 776 29 770 35 770 35 768 29 768 29 762"
				})
			})
		})
	]
});
export default SvgPlus;
